import approveModalRenderMixin from "@/mixins/flow/approve/approveModalRenderMixin.js";

export default {
    mixins: [approveModalRenderMixin],
    components: {},
    props: {},
    data () {
        return {

        };
    },
    computed: {
        flowKeys () {
            return this.appObj.flowKeys;
        },
        customBtnSettings () {
            const btnSettings = this.propsObj.buttonSettings || {
                boxButtons: [],
                dataButtons: []
            };
            const customBtnSettings = {
                boxButtons: [],
                dataButtons: []
            };
            customBtnSettings.boxButtons = btnSettings.boxButtons.filter(btnItem => {
                if (["inputFlow", "selectFlow"].includes(btnItem._type)) {
                    return !!btnItem.flowDefKey && (!this.flowKeys || this.flowKeys.includes(btnItem.flowDefKey));
                } else if (["refInputflow"].includes(btnItem._type)) {
                    return !!btnItem.fieldKey && !!btnItem.refFlowDefKey && (!this.flowKeys || this.flowKeys.includes(btnItem.refFlowDefKey));
                } else if (["referenceBy"].includes(btnItem._type)) {
                    return !!btnItem.fieldKey && (!curScreenFilterBtns.includes("canUpdate") && this.getFormItem(btnItem.fieldKey) && this.getFormItem(btnItem.fieldKey).canEdit);
                } else {
                    return true;
                }
            });
            customBtnSettings.dataButtons = btnSettings.dataButtons.filter(btnItem => {
                if (["inputFlow", "selectFlow"].includes(btnItem._type)) {
                    return !!btnItem.flowDefKey && (!this.flowKeys || this.flowKeys.includes(btnItem.flowDefKey));
                } else if (["refInputflow"].includes(btnItem._type)) {
                    return !!btnItem.fieldKey && !!btnItem.refFlowDefKey && (!this.flowKeys || this.flowKeys.includes(btnItem.refFlowDefKey));
                } else if (["referenceBy"].includes(btnItem._type)) {
                    return !!btnItem.fieldKey;
                } else {
                    return true;
                }
            });
            return customBtnSettings;
        },

        customBoxBtns () {
            return this.customBoxOperationList.map(operationItem => operationItem.type);
        },
        customDataBtns () {
            return this.customDataOperationList.map(operationItem => operationItem.type);
        },
        customDataSelfBtns () {
            return this.customDataSelfOperationList.map(operationItem => operationItem.type);
        },
        customBoxOperationList () {
            return this.customBtnSettings.boxButtons
                .map(btnItem =>
                    ({
                        ...this.customBaseOperationMap[btnItem._type],
                        ...btnItem,
                        type: `${btnItem._type}${btnItem._id}`
                    })
            );
        },
        customDataOperationList () {
            return this.customBtnSettings.dataButtons
                .map(btnItem =>
                    ({
                        ...this.customBaseOperationMap[btnItem._type],
                        ...btnItem,
                        type: `${btnItem._type}${btnItem._id}`
                    })
            );
        },
        customDataSelfOperationList () {
            return this.customDataOperationList.filter(btnItem => ["selectFlow"].includes(btnItem._type));
        },

        customBaseOperationMap () {
            return {
                inputFlow: {
                    name: "发起流程",
                    type: "inputFlow",
                    icon: "md-add",
                    size: "default",
                    event: "clickInputFlow",
                    ...(this.customBtnObj || {})
                },

                selectFlow: {
                    name: "发起修改数据流程",
                    type: "selectFlow",
                    btnType: "text",
                    size: "small",
                    event: "clickSelectFlow",
                    ...(this.customBtnObj || {})
                },
                refInputflow: {
                    name: "发起关联表流程",
                    type: "refInputflow",
                    btnType: "text",
                    size: "small",
                    event: "clickRefInputflow",
                    ...(this.customBtnObj || {})
                },
                referenceBy: {
                    name: "添加关联表数据",
                    type: "referenceBy",
                    btnType: "text",
                    size: "small",
                    event: "clickReferenceBy",
                    ...(this.customBtnObj || {})
                }
            };
        },
        customOperationMap () {
            return this.$arrToMap([].concat(this.customBoxOperationList, this.customDataOperationList), "type");
        }
    },
    methods: {
        // 发起填写表单流程
        clickInputFlow (operationItem) {
            this.curApproveData = {
                flow: {
                    flowDef: operationItem.flowDefKey
                }
            };
            this.openApproveModal();
        },

        /* --------- 数据行相关功能 ------------ */
        // 发起修改数据流程
        clickSelectFlow (operationItem, dataItem, dataIndex) {
            this.curApproveData = {
                data: {
                    _id: dataItem._id
                },
                flow: {
                    flowDef: operationItem.flowDefKey
                }
            };
            this.openApproveModal();

        },
        // 关联表 发起填写表单流程
        clickRefInputflow (operationItem, dataItem, dataIndex) {
            this.$https({
                url: {
                    ...this.urlParams,
                    name: "show"
                },
                params: {
                    _id: dataItem._id,
                    screenKey: this.screenKey
                },
                callback: data => {
                    this.curReferenceByForm = this.curScreenFormList.find(formItem => formItem._key === operationItem.fieldKey);
                    const filterField = this.curReferenceByForm._filterField;

                    this.curApproveData = {
                        data: {
                            [filterField]: data
                        },
                        flow: {
                            flowDef: operationItem.refFlowDefKey
                        }
                    };
                    this.approvePropsObj = {
                        disabledFields: [filterField]
                    };
                    this.openApproveModal();
                }
            });
        },
        // 添加关联表数据
        clickReferenceBy (operationItem, dataItem, dataIndex) {
            this.$https({
                url: {
                    ...this.urlParams,
                    name: "show"
                },
                params: {
                    _id: dataItem._id,
                    screenKey: this.screenKey
                },
                callback: data => {
                    this.curReferenceByForm = this.curScreenFormList.find(formItem => formItem._key === operationItem.fieldKey);
                    const filterField = this.curReferenceByForm._filterField;

                    this.clickCreate(operationItem, {
                        [filterField]: data
                    });
                    this.dshRenderName = "refBUpdateModalRender";
                    this.referenceByPropsObj = this.curReferenceByForm;
                    this.referenceByModObj = undefined;
                    this.referenceByDisabledFields = [filterField];
                }
            });

            // this.curRow = dataItem;
            // this.sheetSelectPropsObj = this.curScreenFormList.find(formItem => formItem._key === operationItem.fieldKey);
            // this.sheetSelectSearchParams = {
            //     $or: [
            //         {
            //             [filterField]: {
            //                 $eq: null
            //             }
            //         }
            //     ]
            // };
            // this.openSheetSelectModal();
        },
        // // 批量选择完成的回调
        // batchSelectCb (ids, list) {
        //     this.$https({
        //         url: {
        //             ...this.urlParams,
        //             name: "update"
        //         },
        //         messageTip: "关联成功！",
        //         params: {
        //             ...this.curRow,
        //             [this.curReferenceByForm._filterField]: {
        //                 delete: [],
        //                 create: ids
        //             },
        //             screenKey: this.screenKey
        //         },
        //         callback: data => {

        //         }
        //     });
        // },

        // 多条关联的编辑框渲染函数
        refBUpdateModalRender (h, params) {
            return this.showUpdateModal
                ? h("sheet-update-modal", {
                    props: {
                        value: this.showUpdateModal,
                        companyId: this.companyId,
                        appId: this.appId,
                        defaultModObj: this.referenceByModObj,
                        canEdit: this.totalCanEdit,
                        isCreate: this.isCreate,
                        dataId: this.dataId,
                        defaultFormData: this.defaultFormData,
                        propsObj: this.referenceByPropsObj
                    },
                    on: {
                        input: this.toggleUpdateModal,
                        createCb: this.createCb,
                        updateCb: this.updateCb
                    }
                })
                : undefined;
        }
    }
};



// WEBPACK FOOTER //
// ./src/mixins/custom/operation/customBtnMixin.js